export default function Insight() {
  const topics = [
    "Produksi vs penghematan — bedanya di mana?",
    "kW, kWp, kWh — apa artinya untuk rumah?",
    "Baterai PLTS — kapan perlu, kapan belum perlu",
    "Backup saat pemadaman — bagaimana cara kerjanya",
    "Kesiapan atap dan struktur sebelum pemasangan",
    "Kualitas instalasi: proteksi, grounding, dan rapi",
    "Rencana Tumbuh — tahap awal yang baik",
  ];
  return (
    <div data-testid="page-insight">
      <div className="pe-container pt-14 pb-16">
        <div className="pe-eyebrow">Insight</div>
        <h1 className="mt-2 font-display font-bold text-3xl lg:text-4xl">Edukasi PLTS untuk pemilik rumah</h1>
        <p className="mt-3 text-[color:var(--pe-text-muted)] max-w-2xl">Topik yang sedang kami siapkan — materi lengkap menyusul dengan sumber dan tanggal yang jelas.</p>
        <ul className="mt-10 grid md:grid-cols-2 gap-4">
          {topics.map((t, i) => (
            <li key={i} className="pe-card">
              <h3 className="font-display font-semibold text-lg">{t}</h3>
              <p className="mt-2 text-sm text-[color:var(--pe-text-muted)]">Status: draft — menunggu publikasi.</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
